import {
  LIST_BRANCH_TEAM_SUMMARY_REQUEST,
  LIST_BRANCH_TEAM_SUMMARY_SUCCESS,
  LIST_BRANCH_TEAM_SUMMARY_FAIL,
  LIST_BRANCH_TEAM_SUMMARY_RESET,
  LIST_BRANCH_TEAM_REQUEST,
  LIST_BRANCH_TEAM_SUCCESS,
  LIST_BRANCH_TEAM_FAIL,
  LIST_BRANCH_TEAM_RESET,
  CREATE_BRANCH_TEAM_REQUEST,
  CREATE_BRANCH_TEAM_SUCCESS,
  CREATE_BRANCH_TEAM_FAIL,
  DETAIL_BRANCH_TEAM_REQUEST,
  DETAIL_BRANCH_TEAM_SUCCESS,
  DETAIL_BRANCH_TEAM_FAIL,
  UPDATE_BRANCH_TEAM_REQUEST,
  UPDATE_BRANCH_TEAM_SUCCESS,
  UPDATE_BRANCH_TEAM_FAIL,
  DELETE_BRANCH_TEAM_REQUEST,
  DELETE_BRANCH_TEAM_SUCCESS,
  DELETE_BRANCH_TEAM_FAIL
} from '../../constants/branch-teams'

const initialState = {
  loading: false,
  branchTeams: [],
  branchTeam: {},
  branchTeamsSummary: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const branchTeamReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BRANCH_TEAM_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_TEAM_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        branchTeamsSummary: action.payload
      }
    case LIST_BRANCH_TEAM_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_BRANCH_TEAM_SUMMARY_RESET:
      return { ...state, loading: false, branchTeamsSummary: [] }
    case LIST_BRANCH_TEAM_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_TEAM_SUCCESS:
      return { ...state, loading: false, branchTeams: action.payload, pageable: action.pageable }
    case LIST_BRANCH_TEAM_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_BRANCH_TEAM_RESET:
      return { ...state, loading: false, branchTeams: [] }
    case CREATE_BRANCH_TEAM_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_BRANCH_TEAM_SUCCESS:
      return { ...state, loadingCreate: false, branchTeams: [...state.branchTeams, action.payload] }
    case CREATE_BRANCH_TEAM_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_BRANCH_TEAM_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_BRANCH_TEAM_SUCCESS:
      return { ...state, loadingDetail: false, branchTeam: action?.payload }
    case DETAIL_BRANCH_TEAM_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_BRANCH_TEAM_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_BRANCH_TEAM_SUCCESS:
      const examinationPayload = action.payload
      const examinationIndex = state.branchTeams.findIndex(branchTeam => branchTeam.id === examinationPayload.id)

      const examinationsUpdate = [...state.branchTeams]
      examinationsUpdate[examinationIndex] = examinationPayload

      return { ...state, loadingUpdate: false, branchTeams: examinationsUpdate }
    case UPDATE_BRANCH_TEAM_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_BRANCH_TEAM_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_BRANCH_TEAM_SUCCESS:
      const examinationId = action.payload

      const examinationIndexDelete = state.branchTeams.findIndex(branchTeam => branchTeam.id === examinationId)
      const examinationsDelete = [...state.branchTeams]

      examinationsDelete.splice(examinationIndexDelete, 1)

      return { ...state, loadingDelete: false, branchTeams: examinationsDelete }
    case DELETE_BRANCH_TEAM_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    default:
      return state
  }
}

export default branchTeamReducer